import { faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EmployeeName } from "components/EmployeeName";
import { OvertimeButtons } from "components/OvertimeButtons";
import { format } from "date-fns";
import React from "react";
import { useAppSelector } from "store/hooks";
import { selectOvertimeById, useGetOvertimesQuery } from "store/reducers/overtime";

type Props = {
  startDate: Date | null;
};

export function SummaryOvertime(props: Props) {
  const { startDate } = props;

  const { data, error, isLoading } = useGetOvertimesQuery(
    { start_date: startDate ? format(startDate, "yyyy-MM-dd") : "" },
    { skip: !startDate },
  );

  // Use the query data here instead of the selector, this avoids them immediately disappearing when the status changes
  const pendingOvertime = (data?.overtimes ?? []).filter((overtime) => overtime.status === "pending");

  if (!startDate) return null;

  if (isLoading) {
    return <span>Loading...</span>;
  }

  if (error) {
    return <span>Error loading data.</span>;
  }

  return (
    <div>
      <table className="table">
        <thead>
          <tr>
            <th rowSpan={1} colSpan={4} className="table-header-name">
              <FontAwesomeIcon icon={faClock} /> Overtime Requests
            </th>
          </tr>
          <tr>
            <th className="table-header-column-name w-1/12">Employee</th>
            <th className="table-header-column-name w-2/12">Date</th>
            <th className="table-header-column-name w-3/12">Notes</th>
            <th className="table-header-column-name w-1/12">Action</th>
          </tr>
        </thead>
        <tbody>
          {pendingOvertime.map((overtime) => (
            // We use overtimeId so that it gets the latest data from the store
            <PendingOvertime key={overtime.id} overtimeId={overtime.id} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

function PendingOvertime({ overtimeId }: { overtimeId: number }) {
  const overtime = useAppSelector((state) => selectOvertimeById(state, overtimeId));

  if (!overtime) return null;

  return (
    <tr key={overtime.id}>
      <td className="table-body-cell">
        <EmployeeName employeeId={overtime.employee_id} />
      </td>
      <td className="table-body-cell">{format(new Date(overtime.when), "dd-MM-yyyy")}</td>
      <td className="table-body-cell break-all">{overtime.reason}</td>
      <td className="table-body-cell">
        <OvertimeButtons
          date={overtime.when}
          timesheetEmployeeId={overtime.employee_id}
          parent="SUMMARY"
          overtime={overtime}
          overtimeDuration={null}
        />
      </td>
    </tr>
  );
}
